import React, { useState } from "react";
import SEO from "../common/SEO";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import FooterOne from "../common/footer/FooterOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import FormTwo from "../component/contact/FormTwo";
import HeaderFour from "../common/header/HeaderFour";
import ChatbotTwo from "./ChatbotTwo.js";
import "bootstrap/dist/css/bootstrap.min.css";
import ElegantPopup1 from "../common/Popup.js";

const Contact = () => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <>
      <style>
        {`
            .contact-section {
              position: relative;
              overflow: hidden;
            }

            .contact-card {
              background: white;
              border: 2px solid #6600cc; /* Purple border */
              transition: transform 0.3s ease;
            }

            .contact-card:hover {
              transform: translateY(-1px);
            }

            .contact-info {
              border: 1px solid #006600; /* Green border */
            }

            .text-purple {
              color: #6600cc !important;
            }

            .text-green {
              color: #006600 !important;
            }

            .shape-container {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              pointer-events: none;
            }

            .shape {
              position: absolute;
              opacity: 0.5;
              animation: float 6s ease-in-out infinite;
            }

            .shape-1 {
              width: 100px;
              top: 10%;
              left: 5%;
              filter: hue-rotate(0deg) saturate(200%) brightness(80%); /* Purple tint */
            }

            .shape-2 {
              width: 80px;
              top: 60%;
              right: 10%;
              filter: hue-rotate(120deg) saturate(200%) brightness(80%); /* Green tint */
            }

            .shape-3 {
              width: 120px;
              bottom: 15%;
              left: 20%;
              filter: hue-rotate(0deg) saturate(200%) brightness(80%); /* Purple tint */
            }

            @keyframes float {
              0% {
                transform: translateY(0px);
              }
              50% {
                transform: translateY(-20px);
              }
              100% {
                transform: translateY(0px);
              }
            }

            /* Responsive adjustments */
            @media (max-width: 768px) {
              .contact-card,
              .contact-info {
                margin-bottom: 20px;
              }
              
              .shape {
                width: 60px;
              }
            }
          `}
      </style>
      <SEO />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderFour />
        <BreadCrumbOne title="Contact Us" page="Contact" />

        <section className="contact-section">
          <div className="container">
            <div className="row g-4 align-items-stretch">
              <div className="col-lg-6">
                <div className="contact-card h-100 p-4 shadow-lg rounded-3">
                  <h3 className="mb-2 fw-bold text-purple">Help Center</h3>
                  <p className="mb-4 text-green fw-semibold">
                    "We're here to assist you!"
                  </p>
                  <FormTwo onSuccess={() => setShowPopup(true)} />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="contact-info h-100 p-4 bg-light rounded-3 shadow-sm">
                  <img
                    src={process.env.PUBLIC_URL + "/images/404/contact.jpg"}
                    alt="Contact"
                    className="contact-image"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Decorative Shapes */}
          <div className="shape-container">
            <img
              src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
              alt="Bubble"
              className="shape shape-2"
            />
            <img
              src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
              alt="Circle"
              className="shape shape-3"
            />
          </div>
        </section>

        <FooterOne parentClass="pt-5" />
        <ChatbotTwo />
      </main>
    </>
  );
};

export default Contact;
